const state = {
  listaItensGlossario: [],
  dialogEdicao: false,
  listaTiposDocumento: []
}

export default state
